<div class="home-page">
  <app-banner></app-banner>
  <div class="container page">
    <div class="row">
      <div class="col-md-9">
        <app-feed-toggler></app-feed-toggler>
        <app-feed [apiUrl]="apiUrl"></app-feed>
      </div>
      <div class="col-md-3"><app-popular-tags></app-popular-tags></div>
    </div>
  </div>
</div>
